import React from 'react';
import { Layout, Typography } from 'antd';
import { motion } from 'framer-motion';
import { standardVariants } from '../utils/useAnimations';
import { AccessibleButton } from '../components/AccessibleButton';

const { Content } = Layout;
const { Title, Paragraph } = Typography;

export const HandicapsPage: React.FC = () => {
  return (
    <Content role="main" aria-label="Page des handicaps">
      <section className="max-w-[1440px] mx-auto px-20 py-40 text-center min-h-[80vh] flex flex-col justify-center">
        <motion.div
          variants={standardVariants}
          initial="hidden"
          animate="visible"
          className="max-w-2xl mx-auto"
        >
          <Title level={1} className="!text-4xl !font-bold !mb-6">
            Les handicaps dans le numérique
          </Title>
          
          <Paragraph className="!text-lg !text-neutral-600 !mb-8">
            Cette page est actuellement en cours de développement. Nous travaillons à créer un contenu riche et accessible pour vous présenter les différents types de handicaps et leurs impacts sur l'expérience numérique.
          </Paragraph>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <AccessibleButton 
              type="primary"
              href="/"
              isLink={true}
              ariaLabelKey="navigation.backToHome"
            >
              Retour à l'accueil
            </AccessibleButton>
            
            <AccessibleButton  
              type="secondary"
              href="/#parcours"
              isLink={true}
              ariaLabelKey="buttons.startAdventure"
            >
              Découvrir les parcours
            </AccessibleButton>
          </div>
        </motion.div>
      </section>
    </Content>
  );
};